/* Raffie's Kids Club v2 — gedrag voor alle rk2-secties.
   Wordt door elke sectie geladen (dedupe via defer+src); init draait één keer
   en opnieuw per sectie bij shopify:section:load (theme-editor). */
(function () {
  var NS = 'http://www.w3.org/2000/svg';

  /* reveal on scroll */
  var revealIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('in', e.isIntersecting); });
  }, { threshold: 0.16 });

  /* route tekent zich + speelt opnieuw bij terugscrollen */
  var routeIO = new IntersectionObserver(function (es) {
    es.forEach(function (e) { e.target.classList.toggle('drawn', e.isIntersecting); });
  }, { threshold: 0.35 });

  /* checklist-items één voor één binnen */
  var listIO = new IntersectionObserver(function (es) {
    es.filter(function (e) { return e.isIntersecting; }).forEach(function (e, i) {
      setTimeout(function () { e.target.classList.add('in'); }, i * 140);
      listIO.unobserve(e.target);
    });
  }, { threshold: 0.5, rootMargin: '0px 0px -8% 0px' });

  function initRoot(root) {
    root = root || document;

    root.querySelectorAll('.rk2 .rv-up').forEach(function (el) {
      if (el.dataset.rk2r) return; el.dataset.rk2r = '1';
      revealIO.observe(el);
    });

    /* haltes: ping-ring + voetstapjes op de lijn, dan observeren */
    root.querySelectorAll('.rk2 .halte, .rk2 .route-start').forEach(function (h) {
      if (h.dataset.rk2h) return; h.dataset.rk2h = '1';
      var pc = h.querySelector('.pin-c');
      if (pc) {
        var ping = document.createElementNS(NS, 'circle');
        ping.setAttribute('class', 'pin-ping');
        ping.setAttribute('cx', pc.getAttribute('cx'));
        ping.setAttribute('cy', pc.getAttribute('cy'));
        ping.setAttribute('r', pc.getAttribute('r'));
        pc.parentNode.insertBefore(ping, pc);
      }
      var path = h.querySelector('.route-path');
      if (path && path.getTotalLength) {
        var svg = path.ownerSVGElement, len = path.getTotalLength();
        [0.20, 0.45, 0.68].forEach(function (t, i) {
          var p = path.getPointAtLength(len * t), p2 = path.getPointAtLength(Math.min(len * t + 3, len));
          var dx = p2.x - p.x, dy = p2.y - p.y, m = Math.hypot(dx, dy) || 1;
          var nx = -dy / m, ny = dx / m, off = (i % 2 ? 1 : -1) * 6.5;
          var fx = p.x + nx * off, fy = p.y + ny * off, ang = Math.atan2(dy, dx) * 180 / Math.PI + 90;
          var fs = document.createElementNS(NS, 'ellipse');
          fs.setAttribute('class', 'footstep f' + (i + 1));
          fs.setAttribute('cx', fx); fs.setAttribute('cy', fy);
          fs.setAttribute('rx', 3); fs.setAttribute('ry', 4.6);
          fs.setAttribute('transform', 'rotate(' + ang.toFixed(1) + ' ' + fx.toFixed(1) + ' ' + fy.toFixed(1) + ')');
          svg.appendChild(fs);
        });
      }
      routeIO.observe(h);
    });

    /* kleur-swatches: andere Raffie */
    root.querySelectorAll('.rk2 .sw-dots i[data-img]').forEach(function (dot) {
      if (dot.dataset.rk2s) return; dot.dataset.rk2s = '1';
      var pick = function () {
        document.querySelectorAll('.rk2 .hero-raffie').forEach(function (img) {
          img.src = dot.dataset.img;
          img.removeAttribute('srcset');
        });
      };
      dot.addEventListener('click', pick);
      dot.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); pick(); }
      });
    });

    /* welkomstbox opent bij klik of toets */
    root.querySelectorAll('.rk2 .box-vis').forEach(function (box) {
      if (box.dataset.rk2b) return; box.dataset.rk2b = '1';
      var open = function () { box.classList.toggle('opened'); };
      box.addEventListener('click', open);
      box.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); }
      });
    });

    /* checklist-items */
    root.querySelectorAll('.rk2 .box-list .bx-item').forEach(function (el) {
      if (el.dataset.rk2l) return; el.dataset.rk2l = '1';
      listIO.observe(el);
    });

    /* faq-accordeon */
    root.querySelectorAll('.rk2 .q button').forEach(function (b) {
      if (b.dataset.rk2q) return; b.dataset.rk2q = '1';
      b.setAttribute('aria-expanded', 'false');
      b.addEventListener('click', function () {
        var q = b.parentElement, a = q.querySelector('.a'), open = q.classList.contains('open');
        var faq = b.closest('.faq') || document;
        faq.querySelectorAll('.q').forEach(function (x) {
          x.classList.remove('open');
          x.querySelector('.a').style.maxHeight = null;
          x.querySelector('button').setAttribute('aria-expanded', 'false');
        });
        if (!open) {
          q.classList.add('open');
          a.style.maxHeight = a.scrollHeight + 'px';
          b.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }

  if (document.readyState !== 'loading') initRoot();
  else document.addEventListener('DOMContentLoaded', function () { initRoot(); });
  document.addEventListener('shopify:section:load', function (e) { initRoot(e.target); });
})();
